/* eslint-disable no-unused-vars */
import Vue from "vue";
import Vuetify from "vuetify";
import "@fortawesome/fontawesome-free/css/all.css";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: false,
  theme: { disable: true },
  icons: {
    iconfont: "fa",
  },
});
